import { render, staticRenderFns } from "./DeletedOrders.vue?vue&type=template&id=d208b1b2&scoped=true&"
import script from "./DeletedOrders.vue?vue&type=script&lang=js&"
export * from "./DeletedOrders.vue?vue&type=script&lang=js&"
import style0 from "./DeletedOrders.vue?vue&type=style&index=0&id=d208b1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d208b1b2",
  null
  
)

export default component.exports